import { useTranslation } from "react-i18next";
import {useState, useEffect, useContext} from "react";
import {useDispatch, useSelector} from "react-redux";
import DelimiterInput from "../DelimiterInput";
import {treeActions} from "../../../redux/slices/treeSlice";
import GroupByName from "../GroupByName";
import TPCheckbox from '../TPCheckbox';
import { Stack } from "@mui/material";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

export default function NVPForm() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx); 
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const dispatch = useDispatch();
  const [recordDelimiter, setRecordDelimiter] = useState(false);
  const [valBegin, setValBegin] = useState(false);
  const [valEnd, setValEnd] = useState(false);
  const [stripQuotes, setStripQuotes] = useState(false);
  const [decodeData, setDecodeData] = useState(false);

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    setRecordDelimiter(header.LINEDELIMITER || '');
    setValBegin(header.VAL_BEGIN_DELIMITER || '');
    setValEnd(header.VAL_END_DELIMITER || '');
    setStripQuotes(
      header.UNCSV ?
        (typeof header.UNCSV === 'boolean' && header.UNCSV) || header.UNCSV === "TRUE" || false
        : false
    );
    setDecodeData(
      header.URLDECODE ?
        (typeof header.URLDECODE === 'boolean' && header.URLDECODE) || header.URLDECODE === "TRUE" || false
        : false
    );
  }, [rightTree.tree.templateHeader])

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({ screen: parentScreen, key, value }));
  }
  return (
    <>
      <>
        <DelimiterInput
          default
          label={t('LBL_REC_DELIM_')}
          value={recordDelimiter}
          name={'LINEDELIMITER'}
        />
        <DelimiterInput
          default
          label={t('LBL_VAL_BEGIN_DELIM')}
          value={valBegin}
          name={'VAL_BEGIN_DELIMITER'}
        />
        <DelimiterInput
          default
          label={t('LBL_END_DELIM')}
          value={valEnd}
          name={'VAL_END_DELIMITER'}
        />
      </>
      <div className="flex flex-wrap">
        <TPCheckbox
          label={t('BTN_STRIP_QUOTES')}
          checked={stripQuotes}
          handleCheck={(checked) => {
            setStripQuotes(checked);
            handleChange('UNCSV', checked);
          }}
        />
        <TPCheckbox 
          label={t('BTN_URLDECODE_DATA')}
          checked={decodeData}
          handleCheck={(checked) => {
            setDecodeData(checked);
            handleChange('URLDECODE', checked);
          }}
        />
      </div>
      <GroupByName />
    </>
  )
}
